// extracted by mini-css-extract-plugin
export default {"body":"AssetTabs_body__sCzIt","header":"AssetTabs_header__QmQZY","title":"AssetTabs_title__VfBFA"};